// User feedback on an assistant reply. Shared because four packages need the
// exact same vocabulary: local-app renders the picker, local-agent relays it,
// cloud-api validates and stores it, admin-dashboard filters and labels it.
//
// The reason codes are mirrored by a CHECK constraint on message_feedback.reason
// (migration 048). Adding a code here therefore REQUIRES a companion migration
// that widens the constraint — otherwise the insert fails at runtime.
export const MESSAGE_FEEDBACK_RATINGS = ["positive", "negative"];
// Ordered as they should appear in the picker: the access/permission cases the
// support team can act on first, the answer-quality cases next, "other" last.
export const MESSAGE_FEEDBACK_REASONS = [
    "missing_permission",
    "cannot_answer",
    "incorrect_answer",
    "no_answer",
    "incomplete_answer",
    "data_mismatch",
    "misunderstood",
    "tool_error",
    "other",
];
export const MESSAGE_FEEDBACK_COMMENT_MAX_LENGTH = 2000;
export function isMessageFeedbackRating(value) {
    return (typeof value === "string" &&
        MESSAGE_FEEDBACK_RATINGS.includes(value));
}
export function isMessageFeedbackReason(value) {
    return (typeof value === "string" &&
        MESSAGE_FEEDBACK_REASONS.includes(value));
}
